import { render } from "./Huisregels.vue?vue&type=template&id=3121e490"
import script from "./Huisregels.vue?vue&type=script&lang=js"
export * from "./Huisregels.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__